import React, { useState, useEffect } from 'react';
import { Tag } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import NoxTable from '../../component/Table';
import { fetchIPay, downloadIPay } from '../../actions/iPayAction';
import InnerHeader from '../../component/InnerHeader';
import Loader from '../../component/Loader/Loader';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const IPay = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();

  const iPays = useSelector(({ iPay }) => iPay.iPays);
  const isLoaded = useSelector(({ iPay }) => iPay.isLoaded);
  const currentProject = useSelector(({ project }) => project.currentProject);

  const onDownloadCsv = () => {
    dispatch(downloadIPay());
  };

  const mapToTable = (iPay) => {
    const data = [];

    iPay?.forEach(
      ({ _id, createdAt, amount, currency, status, externalTransactionId, txId }, index) => {
        const finalStatus = status?.toLowerCase().split('_').join(' ');
        data.push({
          amount,
          createdAt: formatDate(createdAt),
          currency,
          externalTransactionId: externalTransactionId || '-',
          id: _id,
          key: index,
          status: finalStatus,
          transactionId: txId
        });
      }
    );

    return data;
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchIPay());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const columns = [
    {
      dataIndex: 'id',
      key: 'id',
      render: (id) => {
        return <Copy text={id} />;
      },
      sorter: (a, b) => a.id.localeCompare(b.id),
      title: 'User ID'
    },
    {
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => {
        return <Copy text={amount} />;
      },
      sorter: (a, b) => a.amount.toString().localeCompare(b.amount),
      title: 'Amount'
    },
    {
      dataIndex: 'currency',
      key: 'currency',
      render: (currency) => {
        return <Copy text={currency} />;
      },
      sorter: (a, b) => a.currency.toString().localeCompare(b.currency),
      title: 'Currency'
    },
    {
      dataIndex: 'externalTransactionId',
      key: 'externalTransactionId',
      render: (externalTransactionId) => {
        return <Copy text={externalTransactionId} />;
      },
      sorter: (a, b) => a.externalTransactionId.toString().localeCompare(b.externalTransactionId),
      title: 'External Transaction ID'
    },
    {
      dataIndex: 'transactionId',
      key: 'transactionId',
      render: (transactionId) => {
        return <Copy text={transactionId} />;
      },
      sorter: (a, b) => a.transactionId.toString().localeCompare(b.transactionId),
      title: 'Transaction ID'
    },
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => {
        return <Copy text={createdAt} />;
      },
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      title: 'Created'
    },
    {
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        let style = {};
        switch (status) {
          case 'success':
            style = {
              backgroundColor: 'rgba(65, 204, 156, 0.15)',
              border: 'none',
              color: '#41CC9C',
              width: '90%'
            };
            break;
          case 'in progress':
            style = {
              backgroundColor: 'rgba(155, 160, 173, 0.15)',
              border: 'none',
              color: '#9BA0AD',
              width: '90%'
            };
            break;
          case 'error':
            style = {
              backgroundColor: 'rgba(255, 71, 108, 0.15)',
              border: 'none',
              color: '#FF476C',
              width: '90%'
            };
            break;
          case 'created':
            style = {
              backgroundColor: 'rgba(85, 100, 248, 0.15)',
              color: '#5564F8',
              order: 'none',
              width: '80%'
            };
            break;
          default:
            break;
        }

        return (
          <Tag key={status} style={style}>
            {status}
          </Tag>
        );
      },
      sorter: (a, b) => a.status.localeCompare(b.status),
      title: <div>Status</div>
    }
  ];

  const actions = [
    {
      onClick: onDownloadCsv,
      title: 'Download .CSV',
      type: 'primary'
    }
  ];

  const data = mapToTable(iPays);

  if (!currentProject) {
    return <Loader />;
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={data.length} title="iPay" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        loading={!isLoaded}
        searchBy="transactionId"
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default IPay;
